export default "/_next/static/33083a7aa8e6d110d0159665ae2e4a55.png";